<template>
  <div id="about_nav">
    <div class="nav-content">
      <div class="volunteer-box">
        <h3>如何申请分会</h3>
        <p>爱眼基金会支持和鼓励大家加入志愿者的行列，可以成立志愿者分会，专业化服务公益事业</p>
      </div>
      <div class="btn-box">
        <router-link to="/branchApply">
          <button v-if="ifbranch">明白了，申请分会</button>
          <button v-else>查看详情</button>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      ifbranch: true
    };
  },
  methods: {},
  created() {
    let loginInfo = sessionStorage.getItem("token");

    if (loginInfo) {
      this.$db.post(this.$db.config.getVolAndBranchInfo, {}).then(res => {
        if (res.code == 200 && res.data.branch_id) {
          this.ifbranch = false;
          this.$confirm(
            "检测到您是分会管理员是否跳分会管理页面？",
            "确认信息",
            {
              distinguishCancelAndClose: true,
              confirmButtonText: "确认",
              cancelButtonText: "取消"
            }
          )
            .then(() => {
              this.$router.push({ name: "branchApply" });
            })
            .catch(action => {
              // this.$router.push({path:'/'})
              // sessionStorage.removeItem('bread1');
              // sessionStorage.removeItem('index')
            });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#about_nav {
  width: 100%;
}
.nav-content {
  width: 1300px;
  margin: 0 auto;
  .volunteer-box {
    padding-top: 56px;
    > h3 {
      font-size: 30px;
      color: #333333;
      margin-bottom: 30px;
    }
    > p {
      font-size: 16px;
      color: #666666;
      line-height: 30px;
      margin-bottom: 30px;
    }
  }
  .btn-box {
    margin-top: 75px;
    text-align: center;
    margin-bottom: 270px;
    > a {
      > button {
        margin: 0;
        padding: 0;
        border: none;
        outline: none;
        font-size: 21px;
        color: #ffffff;
        width: 261px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        background-color: #c30d23;
        box-shadow: 2px 3px 10px 0px rgba(9, 1, 4, 0.21);
        border-radius: 6px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Branch/branch_index.vue